import { useQuery } from "@tanstack/vue-query";
import { useApi, useToaster } from "@shopexperts/shared";
import { watch } from "vue";

export function useExpertAnalytics() {
    const api = useApi();
    const toaster = useToaster();

    const query = useQuery({
        queryKey: ["expert", "analytics"],
        queryFn: () => api.expert.analytics.getAnalytics(),
        staleTime: 60 * 1000, // 60 seconds (matches API cache TTL)
        gcTime: 5 * 60 * 1000,
    });

    watch(() => query.error.value, (err) => {
        if (err) {
            toaster.create({ title: "Failed to load analytics", type: "error" });
        }
    });

    return query;
}
